module.exports = __webpack_public_path__ + "static/media/chart2.c8af0fed.png";